


















import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import {
    FetchServiceContract,
    CONTRACTS,
    EventsServiceContract,
    Events
    } from '@/core/contracts';
import { lookupField } from '@/core/helpers';
import { localize } from '../../core/filters';
import { StructuredResult } from '@/dto';
import MicroeconomicsDetailsTable from './MicroeconomicsDetailsTable.vue';
import { ContextsState } from '@/store';
import { MicroeconomicsPageArgs, MicroeconomicsRecord } from './types';

@Component({
    components: {
        MicroeconomicsDetailsTable,
        TableOptions,
    },
})
export default class MicroeconomicsDetailsPage extends Page {
    @Prop({ default: () => ({}) })
    public args!: MicroeconomicsPageArgs;

    public table: Table | null = null;
    public tableKey: string = 'microeconomics-details-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof MicroeconomicsRecord,
            load: this.load,
        });
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async load() {
        const packAlias = this.args.packAlias;
        const routeIndex = this.args.routeIndex;
        const direction = this.args.direction;
        const contextId = this.args.contextId || ContextsState.currentContextId;
        const url = `/contexts/${contextId}/packs/${packAlias}/${direction}?routeIndex=${routeIndex}`;
        const data = await this._fetchService!.get<
            StructuredResult<MicroeconomicsRecord>
        >(url);
        if (!data) {
            return {
                data: [],
                totalCount: 0,
            };
        }
        this.transform(data);
        const items = data.items || [];

        return {
            data: items,
            totalCount: items.length,
        };
    }

    private transform(data: StructuredResult<MicroeconomicsRecord>) {
        if (!(data && data.items)) {
            return;
        }
        for (let index = 0; index < data.items.length; index++) {
            const item = data.items[index];
            item.id = index;

            lookupField(item, 'product', data.products);
            lookupField(item, 'owner', data.owners);
            lookupField(item, 'project', data.projects);
            lookupField(item, 'object', data.objects);

            // FIXME:
            item.event = localize(`EventType_${item.event}`);
            (item as any).volume =
                item.quantity / (item as any).product.displayDenominator;
        }
    }
}
